'use strict';
module.exports = function TokenParser() {
	const parseJWT  = (token) => {
		try {
			const base64Url = token.split('.')[1],
				base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
			return JSON.parse(atob(base64));
		} catch (e) {
			return false;
		}
	};
	Object.freeze(Object.assign(this, {parseJWT}));
};
